import React from 'react';
import Icon from '../../../components/AppIcon';

const FunnelAnalysis = ({ steps }) => {
  const maxValue = Math.max(...steps?.map(s => s?.value));

  return (
    <div className="bg-card border border-border rounded-md p-4 md:p-6 shadow-elevation-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Conversion Funnel
        </h3>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Info" size={16} />
          <span>Multi-step form analysis</span>
        </div>
      </div>
      <div className="space-y-4">
        {steps?.map((step, index) => {
          const widthPercentage = (step?.value / maxValue) * 100;
          const dropOffRate = index > 0 
            ? ((steps?.[index - 1]?.value - step?.value) / steps?.[index - 1]?.value * 100)?.toFixed(1)
            : 0;

          return (
            <div key={step?.id} className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-sm font-medium text-primary">
                      {index + 1}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground">
                      {step?.name}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {step?.value} users ({step?.percentage}%)
                    </p>
                  </div>
                </div>
                {index > 0 && dropOffRate > 0 && (
                  <div className="flex items-center gap-1 text-destructive">
                    <Icon name="TrendingDown" size={14} />
                    <span className="text-xs font-medium">-{dropOffRate}%</span>
                  </div>
                )}
              </div>
              <div className="relative h-12 bg-muted rounded-md overflow-hidden">
                <div
                  className="absolute inset-y-0 left-0 bg-gradient-to-r from-primary to-primary/70 flex items-center justify-end pr-4 transition-smooth"
                  style={{ width: `${widthPercentage}%` }}
                >
                  <span className="text-sm font-medium text-white">
                    {step?.value}
                  </span>
                </div>
              </div>
              {index < steps?.length - 1 && (
                <div className="flex justify-center py-2">
                  <Icon name="ChevronDown" size={20} color="var(--color-muted-foreground)" />
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="mt-6 p-4 bg-muted rounded-md">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Overall Conversion</p>
            <p className="text-lg font-semibold text-foreground">
              {steps?.[steps?.length - 1]?.percentage}%
            </p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Biggest Drop-off</p>
            <p className="text-lg font-semibold text-destructive">
              Step 2 → 3
            </p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Avg. Completion Time</p>
            <p className="text-lg font-semibold text-foreground">
              3m 42s
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FunnelAnalysis;